// extracted by mini-css-extract-plugin
export default {"SelectTemplateTip":"SelectTemplateTip___cupI8"};